import { Injectable } from '@angular/core';
import { gql, Mutation } from 'apollo-angular';

import { Mutation as RootMutation } from 'graphql/models/generated';
import { QUOTE_PRICING_STATE_FRAGMENT } from 'graphql/fragments/quote-pricing-state'

export const SET_AUTO_UPDATE_PRICES_MUTATION = gql`
  mutation setAutoUpdatePrices($documentVersion: DocumentVersionInput!, $autoUpdatePrices: Boolean!) {
    quotes {
      modify(documentVersion: $documentVersion) {
        setAutoUpdatePrices(autoUpdatePrices: $autoUpdatePrices) {
          documentId
          revision
          locked
          createdByType
          ...QuotePricingStateFragment
        }
      }
    }
  }
  ${QUOTE_PRICING_STATE_FRAGMENT}
`;

@Injectable({
  providedIn: 'root'
})
export class SetAutoUpdatePricesMutation extends Mutation<RootMutation> {
  document = SET_AUTO_UPDATE_PRICES_MUTATION;
}
